// extracted by mini-css-extract-plugin
export default {"StageHeader":"ShopItemDashboardPage_StageHeader__2Dg8r"};